<template>
  <div ref="bookContainer" class="book-container" @mousedown="startDrag" @mousemove="onDrag" @mouseup="endDrag" @mouseleave="endDrag">
    <div class="book" :style="bookStyle">
      <div class="book-face front">
        <img :src="book_info.image" style="width: 100%;height: 100%;" alt="">
      </div>
      <div class="book-face back">
        <img :src="book_info.image_fan" style="width: 100%;height: 100%;" alt="">
      </div>
      <div class="book-face left"></div>
      <div class="book-face right"></div>
      <div class="book-face top"></div>
      <div class="book-face bottom"></div>
      <div class="circle" :style="circleStyle" @click="handelbook3Dread()">
        <div class="circle_li">
          <span>打开</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  book_info: {
    type: Object,
    default: {},
  },
});

const bookContainer = ref(null)
const bookStyle = ref({
  transform: 'rotateX(25deg) rotateY(18deg)', // 初始状态
  transition: 'transform 0.1s ease-out'
})
const circleStyle = ref({
  transform: 'rotateY(-50deg) translateZ(10px)',
  right: 'auto',
  left: '-10px',
  top: '45%'
})

let isDragging = false
let lastMousePosition = { x: 0, y: 0 }
let rotation = { x: 25, y: 18 }
let animationFrame = null;

// 绑定鼠标按下事件
const startDrag = (event) => {
  event.preventDefault(); // 阻止浏览器默认的拖拽行为

  isDragging = true;
  lastMousePosition = { x: event.clientX, y: event.clientY };

  // 禁用过渡效果
  bookStyle.value.transition = 'none';

  // 添加鼠标移动和鼠标松开事件监听
  document.addEventListener('mousemove', onDrag);
  document.addEventListener('mouseup', endDrag);
};

// 拖动时更新书籍的旋转角度
const onDrag = (event) => {
  if (isDragging) {
    // 请求动画帧来确保平滑的更新
    if (animationFrame) cancelAnimationFrame(animationFrame);

    animationFrame = requestAnimationFrame(() => {
      const dx = event.clientX - lastMousePosition.x;
      const dy = event.clientY - lastMousePosition.y;

      if(-(rotation.y+dx * 0.3) > 356 || (rotation.y+dx * 0.3) > 356){
        return
      }
      if(-(rotation.x-dy * 0.3) > 40 || (rotation.x-dy * 0.3) > 40){
        return
      }

      // 更新旋转角度
      rotation.y += dx * 0.3;
      rotation.x -= dy * 0.3;

      // 更新旋转样式
      bookStyle.value.transform = `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`;

      if(-rotation.y > 316 || rotation.y > 218){
        //circleStyle.value.transform = `rotateY(${-rotation.y}deg) translateZ(30px)`;
        //circleStyle.value.right = `-10px`;
        //circleStyle.value.left = `auto`;
      }else if(-rotation.y > 226 || rotation.y > 50){
        circleStyle.value.transform = `rotateY(${-rotation.y}deg) translateZ(10px)`;
        circleStyle.value.right = `auto`;
        circleStyle.value.left = `-10px`;
      }else if(-rotation.y > 190 || rotation.y > 40){
        //circleStyle.value.transform = `rotateY(${-rotation.y}deg) translateZ(30px)`;
        //circleStyle.value.right = `-10px`;
        //circleStyle.value.left = `auto`;
      }else{
        //circleStyle.value.transform = `rotateY(${-rotation.y}deg) translateZ(20px)`;
        //circleStyle.value.right = `-10px`;
        //circleStyle.value.left = `auto`;
      }

      // 更新鼠标位置
      lastMousePosition = { x: event.clientX, y: event.clientY };
    });
  }
};

// 鼠标松开时结束拖拽
const endDrag = () => {
  isDragging = false;

  // 恢复过渡效果
  bookStyle.value.transition = 'transform 0.3s ease-out';

  // 移除鼠标移动和鼠标松开事件监听
  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', endDrag);
};

// 防止拖拽开始时出现默认的鼠标行为
document.addEventListener('dragstart', (event) => event.preventDefault());
setTimeout(() => {
  document.querySelector('.book').addEventListener('mousedown', startDrag);
}, 2000);

// 定义子组件的 `emit` 事件
const emit = defineEmits(['handelbook3Dread']);
// 读书
const handelbook3Dread=()=>{
  emit('handelbook3Dread', true);
};
</script>

<style scoped>
.book-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #f0f0f0; */
  perspective: 1500px; /* 设置视角，产生3D效果 */
}

.book {
  width: 300px;
  height: 460px;
  position: relative;
  transform-style: preserve-3d; /* 保持3D效果 */
  transition: transform 0.1s ease-out;
}

.book-face {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #7c7c7c;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
}

/* 设置书籍的各个面，包括前后左右上下 */
.front {
  background-color: #ffffff;
  transform: rotateY(0deg) translateZ(15px); /* 设置前封面 */
}

.back {
  background-color: #ccccff;
  transform: rotateY(180deg) translateZ(15px); /* 设置后封面 */
}

.left {
  width: 29px;
  background-color: #c2baa6;
  transform: rotateY(-90deg) translateZ(15px) translateX(0px);
}

.right {
  width: 29px;
  background-color: #c2baa6;
  transform: rotateY(90deg) translateZ(285px) translateX(0px);
}

.top {
  height: 29px;
  background-color: #c2baa6;
  transform: rotateX(90deg) translateZ(15px) translateY(0px);
}

.bottom {
  height: 29px;
  background-color: #c2baa6;
  transform: rotateX(-90deg) translateZ(446px) translateY(0px);
}
.circle {
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  z-index: 10;
}
.circle_li{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #000000;
  background-color: rgba(255,255,255,0.8);
  transition: 0.3s;
}
.circle_li span{
  white-space: nowrap;
  position: absolute;
  color: #DBD5C6;
  font-size: 17px;
  right: 0;
  top: 1px;
  opacity: 0;
  transition: 0.3s;
}
.circle_li:hover{
  background-color: rgba(255,255,255,1);
}
.circle_li:hover span{
  opacity: 1;
  right: -43px;
}
</style>
